import EBarDashboardHero from './EBarDashboardHero';

export default EBarDashboardHero;
